import { useEffect, useState } from 'react';

const pad = (n) => String(n).padStart(2, '0');

/** "5 h 12 m" style remaining time for an ISO expiry; re-renders every 30 s (every second under 1 h). */
export function useCountdown(iso) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!iso) return undefined;
    const ms = new Date(iso).getTime() - Date.now();
    const t = setInterval(() => setNow(Date.now()), ms < 3_600_000 ? 1000 : 30_000);
    return () => clearInterval(t);
  }, [iso]);
  if (!iso) return null;
  const left = Math.max(0, new Date(iso).getTime() - now);
  const h = Math.floor(left / 3_600_000);
  const m = Math.floor((left % 3_600_000) / 60_000);
  const s = Math.floor((left % 60_000) / 1000);
  const days = Math.floor(h / 24);
  return { left, h, m, s, days, expired: left <= 0, urgent: left < 48 * 3_600_000,
    text: left <= 0 ? 'expired' : h >= 48 ? `in ${days} days` : h >= 1 ? `in ${h} h ${pad(m)} m` : `in ${m} m ${pad(s)} s` };
}

export function CountdownText({ iso, prefix = 'expires', fallback = '' }) {
  const c = useCountdown(iso);
  if (!c) return fallback || null;
  return <span data-testid="countdown-text" data-urgent={c.urgent}>{prefix} {c.text}</span>;
}
